export enum Role {
  Admin = "Admin",
  Agent = "Agents",
  AdminAgent = "AdminAgents",
  Unknown = "Unknown",
  TPA = "TPA",
  OPS = "OPS",
}
